import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

export default PDFStyleSheet.create({
  title: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    backgroundColor: '#e4e4e4',
    borderTopRightRadius: 100,
    borderTopLeftRadius: 100,
    marginTop: 10,
    paddingHorizontal: 20,
    paddingVertical: 5
  },
  headerTitle: {
    fontSize: 10
  }
})
